.root {
  font-size: var(--font-size-body-1);
  font-style: italic;
  font-weight: var(--font-weight-regular);
}
